export const Rangoli = ({ className = "", style }) => (
    <svg viewBox="0 0 200 200" fill="none" className={className} style={style} aria-hidden="true">
        <circle cx="100" cy="100" r="97" stroke="currentColor" strokeWidth="1" />
        <circle cx="100" cy="100" r="88" stroke="currentColor" strokeWidth="0.6" strokeDasharray="1.5 4" />
        <circle cx="100" cy="100" r="76" stroke="currentColor" strokeWidth="0.9" />
        {Array.from({ length: 16 }).map((_, i) => (
            <g key={i} transform={`rotate(${i * 22.5} 100 100)`}>
                <path
                    d="M100 14 C 110 34, 111 52, 100 68 C 89 52, 90 34, 100 14 Z"
                    stroke="currentColor"
                    strokeWidth="0.9"
                />
            </g>
        ))}
        <circle cx="100" cy="100" r="52" stroke="currentColor" strokeWidth="0.9" />
        {Array.from({ length: 8 }).map((_, i) => (
            <g key={i} transform={`rotate(${i * 45} 100 100)`}>
                <path
                    d="M100 52 C 107 66, 107 78, 100 88 C 93 78, 93 66, 100 52 Z"
                    stroke="currentColor"
                    strokeWidth="0.9"
                />
            </g>
        ))}
        <circle cx="100" cy="100" r="30" stroke="currentColor" strokeWidth="0.9" />
        <circle cx="100" cy="100" r="24" stroke="currentColor" strokeWidth="0.6" strokeDasharray="1.5 3.5" />
        {Array.from({ length: 8 }).map((_, i) => (
            <g key={i} transform={`rotate(${i * 45 + 22.5} 100 100)`}>
                <circle cx="100" cy="80" r="1.6" fill="currentColor" />
            </g>
        ))}
        <circle cx="100" cy="100" r="12" stroke="currentColor" strokeWidth="0.9" />
        <circle cx="100" cy="100" r="4" fill="currentColor" />
        {Array.from({ length: 24 }).map((_, i) => (
            <g key={i} transform={`rotate(${i * 15} 100 100)`}>
                <circle cx="100" cy="6" r="1.4" fill="currentColor" />
            </g>
        ))}
    </svg>
);

export const Diya = ({ className = "", style }) => (
    <svg viewBox="0 0 100 100" fill="none" className={className} style={style} aria-hidden="true">
        <g className="flame-flicker">
            <path
                d="M50 12 C 57 23, 61 30, 61 38 A 11 11 0 1 1 39 38 C 39 30, 43 23, 50 12 Z"
                stroke="currentColor"
                strokeWidth="2"
            />
            <path d="M50 28 C 53 32, 54.5 35, 54.5 38.5 A 4.5 4.5 0 1 1 45.5 38.5 C 45.5 35, 47 32, 50 28 Z" fill="currentColor" />
        </g>
        <path d="M50 50 L 50 56" stroke="currentColor" strokeWidth="2" />
        <path
            d="M18 60 L 82 60 C 82 76, 68 86, 50 86 C 32 86, 18 76, 18 60 Z"
            stroke="currentColor"
            strokeWidth="2"
        />
        <path d="M24 66 C 34 74, 66 74, 76 66" stroke="currentColor" strokeWidth="1.2" />
        <path d="M12 92 L 88 92" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const Lantern = ({ className = "", style }) => (
    <svg viewBox="0 0 60 110" fill="none" className={className} style={style} aria-hidden="true">
        <path d="M30 0 L 30 14" stroke="currentColor" strokeWidth="1.5" />
        <path d="M20 14 L 40 14 L 36 24 L 24 24 Z" stroke="currentColor" strokeWidth="1.5" />
        <path
            d="M16 30 C 16 25, 44 25, 44 30 L 44 66 C 44 71, 16 71, 16 66 Z"
            stroke="currentColor"
            strokeWidth="1.5"
        />
        <path d="M23 26 L 23 70 M30 25 L 30 71 M37 26 L 37 70" stroke="currentColor" strokeWidth="0.8" />
        <path d="M16 42 L 44 42 M16 56 L 44 56" stroke="currentColor" strokeWidth="0.8" />
        <circle cx="30" cy="49" r="5" stroke="currentColor" strokeWidth="1.2" />
        <path d="M24 71 L 36 71 L 33 79 L 27 79 Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M30 79 L 30 90" stroke="currentColor" strokeWidth="1.2" />
        <circle cx="30" cy="94" r="3" stroke="currentColor" strokeWidth="1.2" />
        <path d="M30 97 L 30 106" stroke="currentColor" strokeWidth="1" strokeDasharray="2 2" />
    </svg>
);

export const Bunting = ({ className = "", style }) => (
    <svg viewBox="0 0 300 60" fill="none" className={className} style={style} aria-hidden="true">
        <path d="M0 6 C 75 34, 225 34, 300 6" stroke="currentColor" strokeWidth="1.5" />
        {[0, 1, 2, 3, 4, 5, 6].map((i) => {
            const x = 30 + i * 40;
            const y = 6 + 28 * Math.sin(((x / 300) * Math.PI));
            return (
                <path
                    key={i}
                    d={`M${x - 9} ${y} L ${x + 9} ${y} L ${x} ${y + 16} Z`}
                    stroke="currentColor"
                    strokeWidth="1.3"
                    fill={i % 2 === 0 ? "currentColor" : "none"}
                    fillOpacity={i % 2 === 0 ? 0.35 : 0}
                />
            );
        })}
    </svg>
);

export const Marigold = ({ className = "", style }) => (
    <svg viewBox="0 0 100 100" fill="none" className={className} style={style} aria-hidden="true">
        {Array.from({ length: 12 }).map((_, i) => (
            <g key={i} transform={`rotate(${i * 30} 50 50)`}>
                <path d="M50 8 C 56 20, 56 30, 50 38 C 44 30, 44 20, 50 8 Z" stroke="currentColor" strokeWidth="1.4" />
            </g>
        ))}
        {Array.from({ length: 12 }).map((_, i) => (
            <g key={i} transform={`rotate(${i * 30 + 15} 50 50)`}>
                <path d="M50 22 C 54 30, 54 36, 50 42 C 46 36, 46 30, 50 22 Z" stroke="currentColor" strokeWidth="1.1" />
            </g>
        ))}
        <circle cx="50" cy="50" r="9" stroke="currentColor" strokeWidth="1.4" />
        <circle cx="50" cy="50" r="3" fill="currentColor" />
    </svg>
);

export const Potli = ({ className = "", style }) => (
    <svg viewBox="0 0 100 110" fill="none" className={className} style={style} aria-hidden="true">
        <path d="M38 8 C 42 18, 58 18, 62 8" stroke="currentColor" strokeWidth="1.6" />
        <path d="M36 14 C 30 26, 28 34, 30 42 L 70 42 C 72 34, 70 26, 64 14" stroke="currentColor" strokeWidth="1.8" />
        <path d="M28 40 C 14 52, 12 76, 28 90 C 42 102, 58 102, 72 90 C 88 76, 86 52, 72 40" stroke="currentColor" strokeWidth="1.8" />
        <path d="M30 44 C 42 52, 58 52, 70 44" stroke="currentColor" strokeWidth="1" />
        <path d="M26 58 C 40 66, 60 66, 74 58" stroke="currentColor" strokeWidth="0.8" strokeDasharray="3 3" />
        <circle cx="50" cy="72" r="9" stroke="currentColor" strokeWidth="1.2" />
        {Array.from({ length: 8 }).map((_, i) => (
            <g key={i} transform={`rotate(${i * 45} 50 72)`}>
                <circle cx="50" cy="58" r="1.4" fill="currentColor" />
            </g>
        ))}
        <circle cx="30" cy="40" r="2.4" stroke="currentColor" strokeWidth="1.2" />
        <circle cx="70" cy="40" r="2.4" stroke="currentColor" strokeWidth="1.2" />
        <path d="M30 42 L 24 54 M70 42 L 76 54" stroke="currentColor" strokeWidth="1.2" />
        <circle cx="23" cy="57" r="2" fill="currentColor" />
        <circle cx="77" cy="57" r="2" fill="currentColor" />
    </svg>
);

export const Rakhi = ({ className = "", style }) => (
    <svg viewBox="0 0 160 80" fill="none" className={className} style={style} aria-hidden="true">
        <path d="M0 40 C 30 32, 45 34, 58 38 M0 48 C 30 44, 45 44, 58 42" stroke="currentColor" strokeWidth="1.4" />
        <path d="M160 40 C 130 32, 115 34, 102 38 M160 48 C 130 44, 115 44, 102 42" stroke="currentColor" strokeWidth="1.4" />
        <circle cx="22" cy="40" r="2.5" fill="currentColor" />
        <circle cx="138" cy="40" r="2.5" fill="currentColor" />
        <circle cx="80" cy="40" r="26" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="80" cy="40" r="19" stroke="currentColor" strokeWidth="0.9" strokeDasharray="2 3" />
        {Array.from({ length: 8 }).map((_, i) => (
            <g key={i} transform={`rotate(${i * 45} 80 40)`}>
                <path d="M80 22 C 83 27, 83 31, 80 34 C 77 31, 77 27, 80 22 Z" stroke="currentColor" strokeWidth="1" />
            </g>
        ))}
        <circle cx="80" cy="40" r="6" stroke="currentColor" strokeWidth="1.4" />
        <circle cx="80" cy="40" r="2" fill="currentColor" />
        {Array.from({ length: 8 }).map((_, i) => (
            <g key={i} transform={`rotate(${i * 45 + 22.5} 80 40)`}>
                <circle cx="80" cy="12" r="1.6" fill="currentColor" />
            </g>
        ))}
    </svg>
);

export const Hanging = ({ className = "", style }) => (
    <svg viewBox="0 0 120 100" fill="none" className={className} style={style} aria-hidden="true">
        <path d="M60 0 L 60 10" stroke="currentColor" strokeWidth="1.4" />
        <path d="M46 10 L 74 10 L 68 24 L 52 24 Z" stroke="currentColor" strokeWidth="1.6" />
        <path d="M52 24 C 40 40, 40 58, 60 70 C 80 58, 80 40, 68 24" stroke="currentColor" strokeWidth="1.6" />
        <path d="M60 24 L 60 70 M47 34 C 55 40, 65 40, 73 34 M45 48 C 55 55, 65 55, 75 48" stroke="currentColor" strokeWidth="0.9" />
        <circle cx="60" cy="44" r="4" stroke="currentColor" strokeWidth="1.1" />
        <path d="M60 70 L 60 78" stroke="currentColor" strokeWidth="1.2" />
        {[0, 1, 2, 3, 4].map((i) => (
            <g key={i} transform={`rotate(${(i - 2) * 18} 60 78)`}>
                <path d="M60 78 L 60 92" stroke="currentColor" strokeWidth="1" />
                <circle cx="60" cy="95" r="1.8" fill="currentColor" />
            </g>
        ))}
        <path d="M20 6 C 40 14, 80 14, 100 6" stroke="currentColor" strokeWidth="1" />
        {[0, 1, 2, 3].map((i) => {
            const x = 28 + i * 21;
            return <path key={i} d={`M${x - 6} ${10.5} L ${x + 6} ${10.5} L ${x} ${20} Z`} stroke="currentColor" strokeWidth="0.9" fill="currentColor" fillOpacity={i % 2 ? 0 : 0.3} />;
        })}
    </svg>
);

export const FlameDivider = ({ className = "" }) => (
    <div className={`flex items-center justify-center gap-4 ${className}`} aria-hidden="true">
        <span className="h-px w-16 sm:w-24 bg-current opacity-30" />
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none">
            <path
                d="M12 2 C 15 7, 17 10, 17 14 A 5 5 0 1 1 7 14 C 7 10, 9 7, 12 2 Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
        </svg>
        <span className="h-px w-16 sm:w-24 bg-current opacity-30" />
    </div>
);
